export default __webpack_public_path__ + "static/media/F1_5.47e3d251.png";